<template>
    <common-page flex-column card-content>
        <query-view config-code="pj_release"
                    with-custom-actions-head-of-row>
            <template #headOfRow="{row}">
                <b-button-group>
                    <mini-button v-if="row.releaseStatus !== 3" @btnClick="retry(row)">
                        Retry
                    </mini-button>
                    <mini-button @btnClick="gotoItemList(row)">
                        <i class="fa-solid fa-eye"></i>
                    </mini-button>
                </b-button-group>
            </template>
        </query-view>

        <template #outer>
            <query-view-modal ref="itemList" header="详情"
                              config-code="pj_release_item"
                              :filter="itemFilter"/>
        </template>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import miniTableCheckedMixin from "@/mixin/em/common/stuffs/table/miniTableCheckedMixin";
import QueryViewModal from "@/components/common/display/query-view/QueryViewModal.vue";

export default {
    name: "SithMomPjBCInfo",
    mixins: [miniTableCheckedMixin],
    components: {QueryViewModal, MiniButton, QueryView, CommonPage},
    data() {
        return {
            itemFilter: {
                batchId: null,
            },
        }
    },
    methods: {
        retry(row) {
            if (row.batchCode) {
                this.releaseLoading = true;
                this.$store.dispatch("api/post", {
                    url: `${process.env.VUE_APP_SITHMES_II_URL}/sithMomPjDocument/release/retry?batchCode=${row.batchCode}`,
                    data: {}
                }).then(res => {
                    console.log(res);
                    this.$message.success("success");
                }).finally(() => this.releaseLoading = false);
            }
        },
        gotoItemList(row) {
            this.itemFilter.batchId = row.id;
            this.$refs.itemList.showModal();
        },
    }
}
</script>

<style scoped>

</style>
